var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-flex-item eu-basis_12 eu-basis_12_md eu-basis_6_lg" },
    [
      _c("p", { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _c("p", { staticClass: "emd-card-grid__line" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("after")) +
            " " +
            _vm._s(_vm._f("dateFormat")(_vm.computedData.date, "date")) +
            ", " +
            _vm._s(_vm.$t(_vm.descriptionKey)) +
            " R$ " +
            _vm._s(_vm.computedData.value) +
            " "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }